const data = {
  id: 1,
  title: 'Look and fill in the blank with the correct word.',
  subTitle: 'Nhìn hình và điền từ chính xác vào chỗ trống.',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/three.png',
  questionText: 'What number is it?',
  question: 'It’s number ___',
  // answers: 'three',
  answers: [
    { id: 1, answer: 'three', isCorrect: true },
  ],
};

export default data;
